import { useEffect, useState } from "react";
import { glideLocalStorage } from "../glideLocalStorage";

export function useAccount() {
  const [address, setAddress] = useState<string | undefined>(undefined);

  useEffect(() => {
    const initializeAddress = async () => {
      const storedAddress = await glideLocalStorage.getItem(
        "glide.solana.account",
      );
      setAddress(storedAddress || undefined);
    };

    initializeAddress();
  }, []);

  useEffect(() => {
    const handleAccountChange = () => {
      const newAddress =
        localStorage.getItem("glide.solana.account") || undefined;
      setAddress(newAddress);
    };

    window.addEventListener("glide.solana.account", handleAccountChange);
    return () => {
      window.removeEventListener("glide.solana.account", handleAccountChange);
    };
  }, []);

  return { address, isConnected: !!address };
}
